import { advanceLuckySpark, type LuckySparkRuntimeState } from "../events/lucky-spark";
import { advanceOverdrive } from "../events/overdrive";
import { advanceReactorStormCooldown } from "../events/reactor-storm";
import type { ProfileProgress } from "../progression/levels";
import type { OrbitForgeSave } from "../save/types";
import type { FeedbackDraft } from "./feedback";

export interface RuntimeTimedEventInput {
  readonly save: OrbitForgeSave;
  readonly progress: ProfileProgress;
  readonly luckySpark: LuckySparkRuntimeState;
  readonly deltaSeconds: number;
  readonly stormActive: boolean;
  readonly activePanel: string | null;
  readonly modalBlocked: boolean;
}

export interface RuntimeTimedEventResult {
  readonly dirty: boolean;
  readonly feedback: readonly FeedbackDraft[];
}

export function advanceRuntimeTimedEvents(input: RuntimeTimedEventInput): RuntimeTimedEventResult {
  const feedback: FeedbackDraft[] = [];
  let dirty = advanceReactorStormCooldown(input.save, input.progress, input.deltaSeconds);
  const overdrive = advanceOverdrive(input.save, input.progress, input.deltaSeconds, input.stormActive);
  dirty = dirty || overdrive.dirty;
  feedback.push(...overdrive.feedback);

  const spark = advanceLuckySpark({
    save: input.save,
    state: input.luckySpark,
    progress: input.progress,
    deltaSeconds: input.deltaSeconds,
    activePanel: input.activePanel,
    modalBlocked: input.modalBlocked
  });
  dirty = dirty || spark.dirty;
  feedback.push(...spark.feedback);
  return { dirty, feedback };
}
